import type { Knowledge } from '../../api/types'
import '../../ui/ui.css'
import './kb.css'

const SOURCE: Record<string, string> = { url: '网页', manual: '手写', file: '文件', web: '网页' }

/** 资料来源的叫法：公众号、网页、PDF…… */
export function sourceLabel(doc: Knowledge): string {
  const meta = (doc.custom_metadata ?? {}) as Record<string, unknown>
  if (typeof meta.source_site === 'string' && meta.source_site) return meta.source_site
  if (doc.source && /mp\.weixin\.qq\.com/.test(doc.source)) return '公众号'
  const type = (doc.file_type || '').toLowerCase()
  if (type === 'pdf') return 'PDF'
  if (['md', 'markdown'].includes(type)) return 'Markdown'
  if (['docx', 'doc'].includes(type)) return 'Word'
  if (['png', 'jpg', 'jpeg', 'gif', 'webp'].includes(type)) return '图片'
  return SOURCE[doc.type ?? ''] ?? (type ? type.toUpperCase() : '资料')
}

/** 显示用的标题：去掉导入时带进来的扩展名（「笔记.md」显示成「笔记」）。 */
export const cleanTitle = (t: string) => t.replace(/\.(md|markdown|txt|html?|docx?|pdf)$/i, '')
export const docTitle = (doc: { title?: string; file_name?: string }) => cleanTitle(doc.title || doc.file_name || '') || '未命名资料'

export const parseState = (s: string): 'ready' | 'parsing' | 'failed' =>
  s === 'completed' || s === 'finalizing' ? 'ready' : s === 'failed' || s === 'cancelled' ? 'failed' : 'parsing'

const pad = (n: number) => String(n).padStart(2, '0')
export function shortDate(iso: string): string {
  const d = new Date(iso)
  if (!Number.isFinite(d.getTime())) return ''
  const now = new Date()
  const md = `${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
  return d.getFullYear() === now.getFullYear() ? `${md} ${pad(d.getHours())}:${pad(d.getMinutes())}` : `${d.getFullYear()}-${md}`
}

export function DocCard({ doc, onOpen, showFolder = true }: { doc: Knowledge; onOpen: () => void; showFolder?: boolean }) {
  const state = parseState(doc.parse_status)
  const status = state === 'parsing' ? ' · 正在解析' : state === 'failed' ? ' · 解析失败' : ''
  const folder = showFolder && doc.folder_path ? ` · ${doc.folder_path.split('/').pop()}` : ''
  return (
    <button type="button" className="sk-card doc-card" data-interactive="true" onClick={onOpen}>
      <span className="doc-src">
        <span className="doc-dot" data-status={state} aria-hidden="true" />
        {sourceLabel(doc)}
        {status || folder}
      </span>
      <span className="sk-card-title">{docTitle(doc)}</span>
      {doc.description && <span className="sk-card-body">{doc.description}</span>}
      <span className="sk-card-meta">
        {shortDate(doc.created_at)}
        <span style={{ flex: 1 }} />
        {doc.file_type && <span className="sk-chip">{doc.file_type.toUpperCase()}</span>}
      </span>
    </button>
  )
}
